module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dinerSpending":"Average spending by customer"},"es":{"dinerSpending":"Gasto medio por comensal"}}')
  delete Component.options._Ctor
}
